import { ProductTypes } from '../../types/product/product';

export const categoryFilter = value => {
  return {
    type: 'CAT_FILTER',
    payload: {
      category: value
    }
  };
};

export const rebondFilter = value => {
  return {
    type: 'REBOND_FILTER',
    payload: {
      rebond: value
    }
  };
};

export const searchFilter = value => {
  return {
    type: 'SEARCH_FILTER',
    payload: {
      search: value
    }
  };
};

export const priceFilter = value => {
  return {
    type: 'PRICE_FILTER',
    payload: {
      price: value
    }
  };
};

export const resetFilters = () => {
  return {
    type: 'RESET_FILTERS'
  };
};

export const setProducts = (products: ProductTypes[]) => ({
  type: 'SET_PRODUCTS',
  payload: { products }
});
